import Board from "@lourenci/react-kanban";
import "@lourenci/react-kanban/dist/styles.css";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import LocalErrorBoundary from "../../../../../util/LocalErrorBoundary";
import { selectKanbanBoardColumns } from "../../issueSelectors";
import { thunkOpenIssueModalById } from "../../issueSlice";
import { thunkOnKanbanCardDrop } from "../../issueThunk";
import { KanbanCard } from "./KanbanCard/KanbanCard";

const IssueKanban: React.FC = () => {
  const dispatch = useAppDispatch();
  const kanbanBoardColumns = useAppSelector(selectKanbanBoardColumns);

  return (
    <Board
      disableColumnDrag
      onCardDragEnd={(card, from, to) => dispatch(thunkOnKanbanCardDrop(card, from, to))}
      children={{ columns: kanbanBoardColumns ?? [] }}
      renderCard={({ content }) => (
        <LocalErrorBoundary id={`kanbanCard ${content._id}`}>
          <KanbanCard openContent={() => dispatch(thunkOpenIssueModalById(content._id))} content={content} />
        </LocalErrorBoundary>
      )}
    />
  );
};

export default IssueKanban;
